import { useCallback, useEffect, useRef } from 'react';

/**
 * This will not cause a re-render as it uses ref's instead of state.
 * Utilize the useIsClient() hook when a re-render is desired.
 */
const useIsMounted = () => {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, []);
};

export default useIsMounted;
